import React, { useEffect, useState, useRef } from 'react';
import { FormControlLabel } from '@material-ui/core';
import {MenuItem,Checkbox,TextField} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { Stack } from '@mui/material';
import LevelButtonGroup from './LevelButtonGroup';

function Level3CodeDialog({
  okCallback,
  updateCallback,
  deleteCallback,
  cancelCallback,
  visible,
  types,
  defaultType,
  l1code,
  l2code,
  l3code,
  newCode,
  defaultDescription,
  defaultName,
  defaultAddress,
  defaultContact,
  defaultFreeze,
  updateLevel3,
}) {
  const [type, setType] = useState(defaultType);
  const [freeze, setFreeze] = useState(defaultFreeze);
  const descriptionRef = useRef(null);
    const [form, setForm] = useState({
      level3Code: newCode,
      description: defaultDescription,
      name: defaultName,
      contact: defaultContact,
      address: defaultAddress,
    });

    const handleInputChange = (event) => {
      setForm({
        ...form,
        [event.target.name]: event.target.value,
      });
    };

    console.log(form)

  const handleTypeChange = event => {
    setType(event.target.value);
    setForm({
      ...form,
      name:'',
      contact:'',
      address:''
    })
  };

  const createDataObject = () => {
    return {
        type,
        freeze,
        Discription: form.description,
        l1code,
        l2code,
        code: form.level3Code,
        fullcode: l2code + '-' + form.level3Code,
        name:form.name,
        address:form.address,
        contact:form.contact,
    };
  };

  const handleAdd = () => {
    if (
      type == '' ||
      descriptionRef == '' ||
      l1code == '' ||
      l2code == '' ||
      form.level3Code == ''
    ) {
      alert('Please enter all fields.');
    } else {
      const data = createDataObject();
      okCallback(data);
    }
  };

  const handleCancel = () => {
    cancelCallback();
  };
  const handleUpdate = () => {
    const data = createDataObject();
    updateCallback(data);
  };
  const handleDelete = () => {
    const data = createDataObject();
    deleteCallback(data);
  };

  const style = {
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#727981',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  };

  return (
    <Dialog style={style} open={visible} onClose={cancelCallback}>
      <Stack
      spacing={1}
        style={{
          minWidth: '40vw',
          // height: '60vh',
          padding: '2rem',
        }}
        alignItems="center"
      >
        <Stack spacing={6} style={{width:'100%'}} direction='row' justifyContent='space-evenly'>
        <TextField
          style={{ width: '80%' }}
          id="standard-basic"
          variant="filled" 
          select
          label="Type"
          defaultValue={defaultType}
          onChange={handleTypeChange}
          disabled={updateLevel3}
          InputProps={{ disableUnderline: true, margin: 'dense' }}
          InputLabelProps={{ shrink: true }}
        >
          {types.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        <FormControlLabel
          control={
            <Checkbox
              checked={freeze}
              onChange={e => {
                setFreeze(e.target.checked);
                descriptionRef.current.focus();
              }}
            />
          }
          label="FREEZE"
        />
        </Stack>

        <TextField
          style={{ width: '100%' }}
          id="l1code"
          label="Level 1 code"
          variant="standard"
          value={l1code}
          disabled={updateLevel3}
          InputProps={{
            disableUnderline: false,
            margin: 'dense',
            readOnly: true,
          }}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          style={{ width: '100%' }}
          id="l2code"
          label="Level 2 code"
          variant="standard"
          disabled={updateLevel3}
          value={l2code}
          InputProps={{
            disableUnderline: false,
            margin: 'dense',
            readOnly: true,
          }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          onChange={handleInputChange}
          name="level3Code"
          style={{ width: '100%' }}
          required
          id="outlined-required"
          label="Level 3 code"
          variant="standard"
          disabled={updateLevel3}
          type="number"
          value={form.level3Code}
        />
        <TextField
          onChange={handleInputChange}
          name='description'
          style={{ width: '100%' }}
          required
          inputRef={descriptionRef}
          value={form.description}
          id="outlined-required"
          label="Description"
          variant="standard"
        />
        {type == 'CLIENT' || type == 'SUPPLIER' ? (

          <Stack width='100%' spacing={1}>
                <TextField
              onChange={handleInputChange}
              name='name'
              style={{ width: '100%' }}
              required
              id="cname"
              value={form.name}
              label="Name"
              variant="standard"
              />
              <TextField
                onChange={handleInputChange}
                name="contact"
                style={{ width: '100%' }}
                required
                id="contact"
                value={form.contact}
                label="Contact"
                variant="standard"
              />
              <TextField
                onChange={handleInputChange}
                name="address"
                value={form.address}
                style={{ width: '100%' }}
                required
                id="address"
                label="Address"
                variant="standard"
              />
            
          </Stack>
        ) : (
          <></>
        )}

        <LevelButtonGroup
          updateLevel={updateLevel3}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          handleCancel={handleCancel}
          handleAdd={handleAdd}
        />
      </Stack>
    </Dialog>
  );
}

export default Level3CodeDialog;
